#import "../fragments/contact-info-fragment.graphql"

query GetContactInfo($id: ID!) {
    contact(id: $id) {
        ...ContactInfoFragment
    }
}
